import type {ReactNode} from 'react';
import {NavLink} from 'react-router-dom';

import {cn} from '@/utils/ui';

export type FloatingMenuItemProps = {
  onClick?: () => void;
  path?: string;
  className?: string;
  text: string;
  icon: ReactNode;
};

const classNames = cn(
  'flex flex-col items-center justify-center transition-all',
  'w-16 h-16',
  'rounded-full bg-transparent text-secondary-700',
  'hover:bg-primary-100 hover:text-secondary-700',
  'focus:bg-primary-100 focus:text-secondary-700',
  'pt-2 pb-3 px-2 type-navigation',
  '[&>svg]:w-[24px] [&>svg]:h-[24px]'
);

const FloatingMenuItem = ({
  path,
  onClick,
  text,
  icon,
  className,
}: FloatingMenuItemProps) => {
  if (!onClick && !path) {
    throw new Error('Either onClick or path must be provided');
  }

  if (onClick) {
    return (
      <button className={cn(classNames, className)} onClick={onClick}>
        {icon}
        {text}
      </button>
    );
  }

  return (
    <NavLink
      className={({isActive}) =>
        cn(
          classNames,
          'group',
          {
            'bg-secondary-700! text-white!': isActive,
          },
          className
        )
      }
      to={path!}
    >
      {icon}
      {text}
    </NavLink>
  );
};

export default FloatingMenuItem;
